/**
 * 课程标准 api
 * 课程标准api
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';




  /**
   * The CourseStandardEditForm model module.
   * @module course_standard/model/CourseStandardEditForm
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>CourseStandardEditForm</code>.
   * @alias module:course_standard/model/CourseStandardEditForm
   * @class
   */
  var exports = function() {
    var _this = this;






  };

  /**
   * Constructs a <code>CourseStandardEditForm</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:course_standard/model/CourseStandardEditForm} obj Optional instance to populate.
   * @return {module:course_standard/model/CourseStandardEditForm} The populated <code>CourseStandardEditForm</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'name')) {
        obj['name'] = ApiClient.convertToType(data['name'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'version')) {
        obj['version'] = ApiClient.convertToType(data['version'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'code')) {
        obj['code'] = ApiClient.convertToType(data['code'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'summary')) {
        obj['summary'] = ApiClient.convertToType(data['summary'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'status')) {
        obj['status'] = ApiClient.convertToType(data['status'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * 班课名称
   * @member {String} name
   */
  exports.prototype['name'] = undefined;
  /**
   * 班课名称
   * @member {String} version
   */
  exports.prototype['version'] = undefined;
  /**
   * 课程号
   * @member {String} code
   */
  exports.prototype['code'] = undefined;
  /**
   * 课程摘要
   * @member {String} summary
   */
  exports.prototype['summary'] = undefined;
  /**
   * 状态 0删除 1未发布，2发布
   * @member {Integer} status
   */
  exports.prototype['status'] = undefined;



  export default exports;
;


